function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.241 3.75569C12.4251 3.93978 12.4405 4.22871 12.2871 4.4303L12.2411 4.483L8.72612 7.99912L12.2425 11.5155C12.4433 11.7163 12.4433 12.042 12.2425 12.2428C12.0584 12.4269 11.7694 12.4423 11.5678 12.2889L11.5152 12.2429L7.99878 8.72646L4.48471 12.2425C4.28392 12.4434 3.95824 12.4435 3.75743 12.2427C3.57335 12.0586 3.5579 11.7697 3.71133 11.5681L3.75734 11.5154L7.27156 7.99924L3.75713 4.48482C3.55631 4.284 3.55635 3.95838 3.75719 3.75753C3.9413 3.57342 4.23025 3.55805 4.43183 3.71143L4.48447 3.75748L7.99889 7.2719L11.5137 3.75592C11.7145 3.55502 12.0402 3.55488 12.241 3.75569Z"
});

var SvgDropdownReset = function SvgDropdownReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdownReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown_reset.bf7c1e4f.svg";
export { ForwardRef as ReactComponent };